import { render, staticRenderFns } from "./right_structure.vue?vue&type=template&id=7bc14dc4"
import script from "./right_structure.vue?vue&type=script&lang=js"
export * from "./right_structure.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports